import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fadeUp, scrollToId } from "@/components/landing/shared";
import { useSiteContent } from "@/context/ContentContext";

export default function FinalCTA() {
  const { final_cta: cta } = useSiteContent();
  return (
    <section className="relative overflow-hidden border-t border-black/[0.08] py-20 md:py-28">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-[-80px] h-[300px]"
        style={{
          background:
            "radial-gradient(closest-side, rgba(16,185,129,0.16), transparent 72%)",
        }}
      />
      <div className="relative mx-auto w-full max-w-4xl px-5 text-center sm:px-6 lg:px-8">
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          className="mx-auto max-w-3xl text-3xl font-semibold leading-[1.06] tracking-[-0.04em] text-[color:var(--text-primary)] sm:text-4xl lg:text-5xl"
        >
          {cta.headline}
          <br />
          <span className="text-emerald-600">{cta.headline_accent}</span>
        </motion.h2>

        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          variants={fadeUp}
          custom={1}
          className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-secondary md:text-lg"
        >
          {cta.body}
        </motion.p>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          variants={fadeUp}
          custom={2}
          className="mt-9 flex justify-center"
        >
          <Button
            data-testid="final-cta-button"
            onClick={() => scrollToId("#contatto")}
            className="h-13 rounded-xl bg-emerald-700 px-7 py-3.5 text-[15px] font-medium text-white transition-colors duration-200 hover:bg-emerald-600"
          >
            {cta.cta}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
